import { StyleSheet } from 'react-native';
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const moneySummaryStyles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    minWidth: 0,
  },
  label: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.ink2,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    flexShrink: 0,
    fontFamily: ticketFonts.sans,
  },
  labelCompact: {
    fontSize: 10,
    lineHeight: 12,
  },
  labelDiscount: {
    textTransform: 'none',
    fontWeight: '700',
    letterSpacing: 0,
    flex: 1,
    minWidth: 0,
  },
  value: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink2,
    fontVariant: ['tabular-nums'],
    textAlign: 'right',
    flexShrink: 1,
    minWidth: 0,
    fontFamily: ticketFonts.mono,
  },
  valueCompact: {
    fontSize: 14,
  },
  valueTotal: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontWeight: '900',
    fontSize: 22,
    lineHeight: 26,
    fontFamily: ticketFonts.mono,
  },
  valueTotalCompact: {
    fontSize: 22,
    lineHeight: 26,
  },
  valueDiscount: {
    color: ticketColors.ok,
  },
  valueSuccess: {
    color: ticketColors.ok,
  },
  valueWarn: {
    color: ticketColors.gold,
  },
});
